import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { moneyTransferApi } from 'src/Services/API';
import { UpdateMoneyTransferDto } from 'src/types/money-transfer.types';

interface Options {
  onSuccess?: () => void;
}

/**
 * Modifie un remboursement, lié ou non. Les mêmes caches que la création sont invalidés :
 * délier une dépense recrédite une part, donc les soldes et la liste des opérations bougent.
 */
export const useUpdateMoneyTransfer = (options?: Options) => {
  const { assetId } = useParams<{ assetId: string }>();
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, data }: { id: string; data: UpdateMoneyTransferDto }) => {
      if (!assetId) throw new Error('Asset ID is missing');
      return moneyTransferApi.update(assetId, id, data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['money-transfers', assetId]);
        queryClient.invalidateQueries(['expenses', assetId]);
        queryClient.invalidateQueries(['fetch-expenses', assetId]);
        queryClient.invalidateQueries(['fetch-expense-balance', assetId]);
        queryClient.invalidateQueries(['fetch-personal-wallet', assetId]);
        queryClient.invalidateQueries(['asset-stats', assetId]);
        options?.onSuccess?.();
      },
    }
  );
};
